// @flow

export const shouldShowNewSidebarAndHeader = ({
  electronCaptionMode,
  firebaseUser,
  history,
  isInConversation,
}: {
  electronCaptionMode: boolean,
  firebaseUser: Object,
  history: Object,
  isInConversation: boolean,
}) => {
  return (
    firebaseUser &&
    !firebaseUser?.isAnonymous &&
    !isInConversation &&
    !electronCaptionMode &&
    !history.location.pathname.includes('/login') &&
    !history.location.pathname.includes('/account/start') &&
    !history.location.pathname.includes('/account/organization/create')
  );
};
